import {SelectBox} from "pages/common/SelectBox"
import {useCallback, useEffect, useState} from "react"
import {Role} from "dto/Role"
import {useFindAllRoles} from "hooks/query/role-query"
import {useParams} from "react-router-dom"
import {useFindGroupById, useRemoveGroupRoleMapping, useUpdateGroupRoleMapping} from "hooks/query/group-query"
import {NotificationType, showNotification} from "common/Notification"

export function UpdateGroupRoleMapping() {
    const {id} = useParams()
    const {data: roles} = useFindAllRoles()
    const {data: group} = useFindGroupById(id)
    const updateRoleMappingMutate = useUpdateGroupRoleMapping()
    const removeRoleMappingMutate = useRemoveGroupRoleMapping()
    const [sourceItem, setSourceItem] = useState<Role | undefined>()
    const [targetItem, setTargetItem] = useState<Role | undefined>()
    const [sourceList, setSourceList] = useState<Role[]>()
    const [targetList, setTargetList] = useState<Role[]>()

    useEffect(() => {
        setSourceList(roles)
    }, [roles])
    useEffect(() => {
        setTargetList(group?.realmRoles?.map<Role>(role => {
            return {name: role}
        }) || [])
    }, [group?.realmRoles])


    const addRole = useCallback(() => {
        if (!sourceItem || !group || !group.id) {
            showNotification("선택한 Role이 없습니다")
            return
        }
        updateRoleMappingMutate.mutate({groupId: group.id, roleName: sourceItem.name}, {
            onSuccess: () => showNotification("추가하였습니다", NotificationType.SUCCESS),
            onError: () => showNotification("추가하지 못했습니다")
        })
    }, [group, sourceItem, updateRoleMappingMutate])
    const removeRole = useCallback(() => {
        if (!targetItem || !group || !group.id) {
            showNotification("선택한 Role이 없습니다")
            return
        }
        removeRoleMappingMutate.mutate({groupId: group.id, roleName: targetItem.name}, {
            onSuccess: () => showNotification("삭제하였습니다", NotificationType.SUCCESS),
            onError: () => showNotification("삭제하지 못했습니다")
        })
    }, [group, removeRoleMappingMutate, targetItem])
    console.log("sourceItem: ", sourceItem)
    return (
        <div className="columns mt20">
            <div className="column">
                <div className=" ml20">
                    <div className="gray-label is-size-85">사용가능한 Roles</div>
                    <SelectBox items={sourceList || []} onChangeItem={(item) => setSourceItem(item)} themeColor="green"/>
                    <div className="mt10">

                        <div className="is-clickable button is-success is-size-85" onClick={() => addRole()}>
                            <span>선택추가</span>
                            <span className="icon">
                                <i className="fa-solid fa-angles-right"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="column">
                <div className=" ml20">
                    <div className="gray-label is-size-85">선택된 Roles</div>
                    <SelectBox items={targetList || []} onChangeItem={(item) => setTargetItem(item)} themeColor="blue"/>
                    <div className="mt10">
                        <div className="is-clickable button is-info is-size-85" onClick={() => removeRole()}>
                            <span className="icon">
                                <i className="fa-solid fa-angles-left"></i>
                            </span><span>선택삭제</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}